import { fetchConToken } from "../../../helpers/fetch";
import { handleErrorApi } from "../../../helpers/randoms";
import { types } from "../../../types/types";
import { startAlerta } from "../../ui/alertas";
import { finishSpinner, startSpinner } from "../../ui/spinner";

export const fetchCosegurosExternos = (idObraSocial) => async (dispatch) => {
    
    try {
        const response = await fetchConToken(`CosegurosExternos/${idObraSocial}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.abmCosegurosExternosSuccess,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los coseguros externos.", "Ha ocurrido un error. Intente Nuevamente")
        dispatch({type: types.abmPlazosError})
    }

}

export const buscarCoseguroExterno = (text) => (dispatch) =>{
    dispatch({
        type : types.abmBuscarCosegurosExternos,
        payload : text
    });
}

export const agregarCoseguroExterno = (data) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        const response = await fetchConToken(`CosegurosExternos`, data, "POST");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Plazo creado correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(fetchCosegurosExternos(data.idObraSocial));
            
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al crear el coseguro externo.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const modificarCoseguroExterno = (data) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        const response = await fetchConToken(`CosegurosExternos`, data, "PUT");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Plazo creado correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(fetchCosegurosExternos(data.idObraSocial));
            
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar el coseguro externo.", "Ha ocurrido un error. Intente nuevamente")
    }
};



export const fetchPracticasCosegurosExternos = (idObraSocial, idOSGrupo) => async (dispatch) => {
    
    try {
        const response = await fetchConToken(`CosegurosExternos/Practicas/${idObraSocial}/${idOSGrupo}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.abmPracticasCosegurosExternosSuccess,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar las practicas.", "Ha ocurrido un error. Intente Nuevamente")
        dispatch({type: types.abmPlazosError})
    }

}


export const fetchCodNomAutor = (idEfectorRed, idEspecialidad, idCentroMedico) => async (dispatch) => {
    
    try {
        const response = await fetchConToken(`CosegurosExternos/CodNomAutor/${idEfectorRed}/${idEspecialidad}/${idCentroMedico}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.abmCodNomAutorSuccess,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar las practicas.", "Ha ocurrido un error. Intente Nuevamente")
        dispatch({type: types.abmPlazosError})
    }

}

export const buscarPracticasCoseguroExterno = (text) => (dispatch) =>{
    dispatch({
        type : types.abmBuscarPracticasCosegurosExternos,
        payload : text
    });
}


export const eliminarPracticasCoseguroExterno = (data) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        const response = await fetchConToken(`CosegurosExternos/Practicas`, data, "DELETE");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("practica eliminada correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(fetchPracticasCosegurosExternos(data.idObraSocial, data.idOSGrupo));
            
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al crear el coseguro externo.", "Ha ocurrido un error. Intente nuevamente")
    }
};


export const nuevaPracticaCoseguro = (idObraSocial, idOSGrupo, idsPracticas, pideAutorizacion, handleClose) => async (dispatch) => {
  
    try {
      dispatch(startSpinner());
      let response = await fetchConToken(`CosegurosExternos/actualizarPracticas/${idObraSocial}/${idOSGrupo}/${pideAutorizacion}`, {idsPracticas}, "PUT");
      const body = await response.json();
  
      if (response.ok) {
        dispatch(
          startAlerta(
            "Practicas guardadas correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        handleClose&& handleClose(false);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar las practicas del coseguro.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };